import { getUserInfo, showError } from './common';
import axios from 'axios';
import { store } from 'store/index';
import { LOGIN } from 'store/actions';
import config from 'config';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '/',
  timeout: 600000
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const uesrinfo = getUserInfo();
      localStorage.removeItem('userinfo');
      store.dispatch({ type: LOGIN, payload: null });
      if (uesrinfo?.role == 1000) {
        window.location.href = config.basename + 'login/enterprise/index';
      } else {
        window.location.href = config.basename + 'login/index';
      }
    }

    if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }

    showError(error);
  }
);
